module.exports = __webpack_public_path__ + "b238a0b3.png";